import React from 'react';
import LiroyText from './LiroyText';
import { defaultFont } from '../../../assets/fonts/defaultFont';

export default function TextMedium20({ children, ...props }) {
    return (
        <LiroyText
            {...props}
            size={20}
            fontWeight={defaultFont.medium}
        >
            {children}
        </LiroyText>
    );
}